// extracted by mini-css-extract-plugin
module.exports = {"container":"phatInput_container__X9DsY","header":"phatInput_header__M4lMn","inlineHeader":"phatInput_inlineHeader__J7b_E","input":"phatInput_input__oVmyY"};